export function formResponseMessageVariables(message, result) {
    var msg = message;
    if ((result === null || result === void 0 ? void 0 : result._oid) && (message === null || message === void 0 ? void 0 : message.includes('${_oid}'))) {
        msg = message.replaceAll('${_oid}', result._oid);
    }
    return msg;
}
